/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GMNOverview } from "./GMNOverview";
import {
  GMNOverviewFromJSON,
  GMNOverviewFromJSONTyped,
  GMNOverviewToJSON,
  GMNOverviewToJSONTyped,
} from "./GMNOverview";

/**
 *
 * @export
 * @interface ApiGmnOverviewList200Response
 */
export interface ApiGmnOverviewList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmnOverviewList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmnOverviewList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmnOverviewList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GMNOverview>}
   * @memberof ApiGmnOverviewList200Response
   */
  results: Array<GMNOverview>;
}

/**
 * Check if a given object implements the ApiGmnOverviewList200Response interface.
 */
export function instanceOfApiGmnOverviewList200Response(
  value: object
): value is ApiGmnOverviewList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmnOverviewList200ResponseFromJSON(json: any): ApiGmnOverviewList200Response {
  return ApiGmnOverviewList200ResponseFromJSONTyped(json, false);
}

export function ApiGmnOverviewList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmnOverviewList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GMNOverviewFromJSON),
  };
}

export function ApiGmnOverviewList200ResponseToJSON(json: any): ApiGmnOverviewList200Response {
  return ApiGmnOverviewList200ResponseToJSONTyped(json, false);
}

export function ApiGmnOverviewList200ResponseToJSONTyped(
  value?: ApiGmnOverviewList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GMNOverviewToJSON),
  };
}
